import React, { createContext, useEffect, useMemo, useState } from "react";
import { useContext } from "react";

const AvailabilityContext = createContext();

export function useAvailabilityContext() {
	const context = useContext(AvailabilityContext);

	if (!context) throw new Error("Use availability context within provider.");

	return context;
}

const getSchoolYearsRange = () => {
	const currentDate = new Date();
	const currentYear = currentDate.getFullYear();
	const startOfSchoolYearMonthIndex = 8;
	const currentMonth = currentDate.getMonth() + 1;

	let startYear = currentMonth >= startOfSchoolYearMonthIndex ? currentYear : currentYear - 1;
	return Array.from({ length: 4 }, (_, i) => `${startYear + i}-${startYear + i + 1}`);
};

export const AvailabilityProvider = ({ children }) => {
	const yearsRange = useMemo(() => getSchoolYearsRange(), []);
	const [years, setYears] = useState(yearsRange[0]);
	const [openInstitutions, setOpenInstitutions] = useState(false);
	const [openLegend, setOpenLegend] = useState(false);
	const [communities, setCommunities] = useState([]);
	const [showUncheckModal, setShowUncheckModal] = useState(false);
	const [checkedCommunities, setCheckedCommunities] = useState([]);
	const isStandart =
		communities.length && communities.some((comm) => comm.type !== "S") ? "A" : "S";

	const [type, setType] = useState(isStandart);
	const [communityToUncheck, setCommunityToUncheck] = useState({});

	useEffect(() => {
		const checkCommunity = communities
			.filter((comm) => comm.type === 'A')
			.map((comm) => comm.id);

		if (checkCommunity.length > 0) {
			setCheckedCommunities(checkCommunity);
		} else {
			setCheckedCommunities([]);
		}
	}, [communities]);

	return (
		<AvailabilityContext.Provider
			value={{
				years,
				setYears,
				yearsRange,
				openLegend,
				setOpenLegend,
				openInstitutions,
				setOpenInstitutions,
				communities,
				setCommunities,
				showUncheckModal,
				setShowUncheckModal,
				type,
				checkedCommunities,
				setCheckedCommunities,
				setType,
				isStandart,
				communityToUncheck,
				setCommunityToUncheck
			}}
		>
			{children}
		</AvailabilityContext.Provider>
	);
};
